import { OptionsHelper, showError } from '../../../_metronic/helpers'
import { Button, CustomSelect, IOption, Label, LoadingIndicator, useModal } from '../../components'
import { FC, useEffect, useState } from 'react'
import { ClearanceDto, useAuth } from '../../modules/auth'
import Swal from 'sweetalert2'
import { checkCredential } from '../../modules/public/certificado/core/_request'
import { useCertificado } from '../hooks/useCertificado'

type IProps = {
  onSubmit: () => void
  clearances: ClearanceDto[]
}

export const ClearancesModal: FC<IProps> = ({ onSubmit, clearances }) => {
  const { closeModal } = useModal()
  const { currentUser } = useAuth()
  const { changeTipoCertificado } = useCertificado()

  const [provedor, setProvedor] = useState<IOption<string>>()
  const [listening, setListening] = useState(false)

  useEffect(() => {
    Swal.close()
  }, [])

  useEffect(() => {
    if (!listening || !provedor) return

    const interval = setInterval(async () => {
      try {
        const valid = await checkCredential()

        if (valid) {
          clearInterval(interval)
          onSubmit()
          closeModal()
        }
      } catch (error) {
        showError(error)
      }
    }, 5000)

    return () => clearInterval(interval)
  }, [closeModal, listening, onSubmit, provedor])

  const possuiCertificadoDigital = currentUser?.pessoa?.certificadoDigital

  return (
    <div>
      {possuiCertificadoDigital && (
        <div className='d-flex flex-end'>
          <Button onClick={changeTipoCertificado}>Alterar certificado</Button>
        </div>
      )}
      <Label className='pb-1' isRequired>
        Provedor
      </Label>
      <CustomSelect
        options={OptionsHelper.createOptions(clearances, ['certificado'], 'url')}
        placeholder='Selecione um provedor'
        onChange={(certficado) => {
          setProvedor(certficado)
          setListening(!!certficado)
        }}
      />

      {provedor?.value && (
        <div className='mt-7 mb-3'>
          <iframe title='Provedor' src={provedor.value} className='w-100 h-400px rounded' />
        </div>
      )}
      {listening && <LoadingIndicator message='Aguardando autorização no celular...' />}
    </div>
  )
}
